// extracted by mini-css-extract-plugin
export default {"factorCard":"FactorCard_factorCard__CmSoY","factorIcon":"FactorCard_factorIcon__oUJKk","factorText":"FactorCard_factorText__NuvNo"};